export default __webpack_public_path__ + "static/media/selectArrowIcon.b9710532.svg";